import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { KnBrQuotesCommentsAdapter } from '../../connectors/kn-br-quotes-comments.adapter';
import {
  KnBrQuoteCommentsActions,
  KnBrQuoteCommentsActionTypes,
  KnBrQuoteCommentsCreateFailure,
  KnBrQuoteCommentsLoad,
  KnBrQuoteCommentsLoadFailure,
  KnBrQuoteCommentsLoadSuccess,
  KnBrQuoteCommentsUpdateFailure,
} from '../actions/kn-br-quotes-comments.action';
import { KnBrQuoteLoad } from '../actions/kn-br-quotes.action';

@Injectable()
export class KnBrQuotesCommentsEffects {
  //@Effect()
  loadQuote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsLoadAction),
      mergeMap((action) =>
        this.quotesCommentsAdapter.get(action.entryNumber).pipe(
          map((data: any) => {
            return new KnBrQuoteCommentsLoadSuccess(data);
          }),
          catchError((error: Error) => {
            return of(new KnBrQuoteCommentsLoadFailure(error));
          })
        )
      )
    )
  );

  //@Effect()
  createQuoteComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsCreateAction),
      mergeMap((action) =>
        this.quotesCommentsAdapter.create(action.payload).pipe(
          mergeMap(() => [new KnBrQuoteCommentsLoad(action.payload.entryNumber), new KnBrQuoteLoad(null, false)]),
          catchError((error: Error) => {
            return of(new KnBrQuoteCommentsCreateFailure(error));
          })
        )
      )
    )
  );
  //@Effect({ dispatch: false })
  createSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsCreateSuccessAction),
        map(() => new KnBrQuoteCommentsLoad(0))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  createFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsCreateFailureAction),
        map(() => {
          //Todo
          return;
        })
      ),
    { dispatch: false }
  );

  //@Effect()
  updateQuoteComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsUpdateAction),
      mergeMap((action) =>
        this.quotesCommentsAdapter.update(action.payload).pipe(
          map(() => new KnBrQuoteCommentsLoad(action.payload.entryNumber)),
          catchError((error: Error) => {
            return of(new KnBrQuoteCommentsUpdateFailure(error));
          })
        )
      )
    )
  );

  //@Effect()
  deleteQuoteComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrQuoteCommentsActionTypes.KnBrQuoteCommentsDeleteAction),
      mergeMap((action) =>
        this.quotesCommentsAdapter.delete(action.payload).pipe(
          mergeMap(() => [new KnBrQuoteCommentsLoad(action.payload.entryNumber), new KnBrQuoteLoad(null, false)]),
          catchError((error: Error) => {
            return of(new KnBrQuoteCommentsUpdateFailure(error));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions<KnBrQuoteCommentsActions>,
    private quotesCommentsAdapter: KnBrQuotesCommentsAdapter
  ) {}
}
